import React from 'react';
import { Link } from 'react-router';
import { node, bool, object, string, func, oneOfType } from 'prop-types';
import { pushCtaItem } from "../../utils/datalayer";

class TrackedButtonLink extends React.Component {
	constructor(props) {
		super(props);
	}

	handleClick(e) {
		pushCtaItem(e);
	}

	render() {
		const { to, id, style, className, onClick, target, children, activeClassName, activeStyle, onlyActiveOnIndex } = this.props;

		// console.log("TO: " + to);
		// Removes duplicate slashes but preserves https:// or http://
		const cleanUrl = to.replace(/([^:]\/)\/+/g, '$1');
		// console.log("CLEAN URL: " + cleanUrl);

		return (
			<Link
				to={cleanUrl}
				id={id}
				style={style}
				className={`btn ${className}`}
				onClick={onClick || this.handleClick}
				target={target}
				activeStyle={activeStyle}
				activeClassName={activeClassName}
				onlyActiveOnIndex={onlyActiveOnIndex}
			>
				{children}
			</Link>
		);
	}
}

TrackedButtonLink.propTypes = {
	to: oneOfType([
		string,
		object,
		func// react-router supports location objects too
	]).isRequired,
	id: string,
	style: object,
	className: string,
	onClick: func, // optional override for click handler
	target: string,
	activeStyle: object,
	activeClassName: string,
	onlyActiveOnIndex: bool,
	children: node.isRequired,
};

export default TrackedButtonLink;


// WEBPACK FOOTER //
// ./src/pages/common/TrackedButtonLink.js